<template>
  <div id="app">
    <HelloWorld msg="Welcome to Your Vue.js App"/>
	<!-- <div class="tip">All Rights Reserved. 2024 IREAD CULTURE TECHNOLOGY Inc. ©</div> -->
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'app',
  components: {
    HelloWorld
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
 /* margin: -8px;
  background-image: url('assets/bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  min-height: 100vh; */
}

.tip{
	position: fixed;
	bottom: 30px;
	left: 0;
	right: 0;
	margin: auto;
	width: 100%; 
	font-family: Inter, Inter;
	font-weight: 500;
	font-size: 13px;
	color: #64856B;
	z-index: 1000; /* 确保它在大多数其他内容之上 */
}

</style>
